const QuickLinksArrowIcon = ({
  height = "40px",
  width = "40px",
}: {
  height?: string;
  width?: string;
}) => {
  return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        style={{ width: `${width}`, height: `${height}` }} // Use inline styles here
        viewBox="0 0 24 24"
        fill="none"
      >
        <g clipPath="url(#clip0_589_11467)">
          <path
            d="M12 0C5.38298 0 0 5.38298 0 12C0 18.617 5.38298 24 12 24C18.617 24 24 18.617 24 12C24 5.38298 18.617 0 12 0ZM15.707 12.707L10.707 17.707C10.512 17.902 10.256 18 9.99998 18C9.744 18 9.48797 17.902 9.29297 17.707C8.90198 17.316 8.90198 16.684 9.29297 16.293L13.586 12L9.29302 7.707C8.90203 7.31602 8.90203 6.684 9.29302 6.29302C9.684 5.90203 10.316 5.90203 10.707 6.29302L15.707 11.293C16.098 11.684 16.098 12.316 15.707 12.707Z"
            fill="#183883"
          />
        </g>
        <defs>
          <clipPath id="clip0_589_11467">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
  );
};
export default QuickLinksArrowIcon;
